export default __webpack_public_path__ + "static/media/02.bad17ab5.png";